export const howToBeautiful: string = `
<h3>１.改行のススメ</h3>
<p>改行は「<strong>Shift + Enter</strong>」、段落を分けたい時は「<strong>Enter</strong>」の使い分けをすると読みやすい記事になります。</p>
<h3>２.引用のススメ</h3>
<blockquote><p>視覚的に目立たせたい段落には「引用」の利用がおすすめです。</p></blockquote>
<h3>３.画像のススメ</h3>
<p>Enter &gt; image、または、ドラッグアンドドロップ、コピーアンドペーストで画像を挿入できます。</p>`;
